import { STATUS } from "@/constants/statuses";
import BaseStore from "@/stateManagement/BaseStore";
import { PaginationMeta } from "@apps/iloom_customization/types/PaginationMeta";
import { WishlistItemEntity } from "@apps/wishlist/entities/WishlistItemEntity";
import { StoreConfig } from "@datorama/akita";
import { produce } from "immer";
import { singleton } from "tsyringe";

const isMobile = window.innerWidth <= 600;
export const WISHLISTED_PRODUCTS_LIMIT = isMobile ? 8 : 16;

export interface WishlistedProductsState {
    wishlistedProducts: WishlistItemEntity[];
    status: STATUS;
    meta: PaginationMeta;
    loadMoreStatus: STATUS;
}

const createInitialState = (): WishlistedProductsState => ({
    wishlistedProducts: [],
    status: STATUS.VIRGIN,
    meta: {
        offset: 0,
        limit: WISHLISTED_PRODUCTS_LIMIT,
        total: 0,
    },
    loadMoreStatus: STATUS.VIRGIN,
});

@singleton()
@StoreConfig({ name: "WishlistedProductsStore", producerFn: produce })
class WishlistedProductsStore extends BaseStore<WishlistedProductsState> {
    constructor() {
        super(createInitialState());
    }
}

export default WishlistedProductsStore;
